import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { minWidth, BREAKPOINTS } from 'config/constants';

export const StyledFleetOperatingHoursChart = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: ${kcc.colors.WHITE};
    border: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.GRAY_100};
    padding: ${kcc.spacing.LG};
    font-family: ${kcc.typography.FONT_FAMILY};
    color: ${kcc.colors.TEXT};
    gap: ${kcc.spacing.BASE};

    .fleet-chart__title {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .fleet-chart__info-icon {
        display: inline-flex;
        flex-shrink: 0;
        width: 24px;
        height: 24px;
      }

      h4 {
        font-size: ${kcc.typography.FONT_SIZE.HEADING_4}px;
        font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
        line-height: 24px;
        text-transform: capitalize;
        margin: 0;
      }

      .fleet-chart__info-icon-wrapper {
        width: 24px;
        height: 24px;
      }
    }

    .fleet-chart__wrapper {
      display: flex;
      width: 100%;
      height: 365px;
      flex-direction: row;
      align-items: flex-end;
      justify-content: center;
      gap: ${kcc.spacing.LG};

      .ant-skeleton {
        height: 100%;

        .ant-skeleton-button {
          height: 100%;
        }
      }
    }

    .fleet-chart__actual {
      height: 100%;

      .fleet-chart__col-value {
        text-align: right;
        margin-right: ${kcc.spacing.SM};
      }

      .fleet-chart__col-title {
        align-self: end;
      }
    }

    .fleet-chart__planned {
      height: 100%;

      .fleet-chart__col-value {
        text-align: left;
        margin-left: ${kcc.spacing.SM};
      }
    }

    .fleet-chart__actual-col {
      width: 60px;
      height: 100%;
      background-color: ${kcc.colors.PETROL[600]};

      @media screen and (min-width: ${BREAKPOINTS.XL}px) and (max-width: ${BREAKPOINTS.XXL}px) {
        width: 35px;
      }
    }

    .fleet-chart__planned-col {
      width: 60px;
      height: 100%;
      background-color: ${kcc.colors.GRAY_250};

      @media screen and (min-width: ${BREAKPOINTS.XL}px) and (max-width: ${BREAKPOINTS.XXL}px) {
        width: 35px;
      }
    }

    .fleet-chart__col {
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      height: 100%;
    }

    .fleet-chart__blank-col {
      width: fit-content;
      height: 100%;
      border-top: ${kcc.lineWidth.BORDER}px solid ${kcc.colors.BLACK};
    }

    .fleet-chart__col-value {
      font-size: ${kcc.typography.FONT_SIZE.HEADING_4}px;
      font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BLACK};
      line-height: ${kcc.typography.LINE_HEIGHT.HEADING};
      letter-spacing: 0.36px;
      text-transform: uppercase;
      margin-bottom: 0;
      margin-top: ${kcc.spacing.XXS};
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-word;
      max-width: 80px;

      ${minWidth.xl} {
        font-size: ${kcc.typography.FONT_SIZE.HEADING_3}px;
      }
    }

    .fleet-chart__actual,
    .fleet-chart__planned {
      display: flex;
      flex-direction: column;

      // animation
      opacity: 1;
      transition: opacity ease-in-out 0.25s;

      .fleet-chart__col-title {
        font-size: ${kcc.typography.FONT_SIZE.SM}px;
        font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
        line-height: ${kcc.typography.LINE_HEIGHT.BASE};
        text-align: center;
        width: 60px;
        margin-top: 6px;
        margin-bottom: 0;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;

        @media screen and (min-width: ${BREAKPOINTS.XL}px) and (max-width: ${BREAKPOINTS.XXL}px) {
          width: 35px;
          font-size: ${kcc.typography.FONT_SIZE.XS}px;
        }
      }
    }

    .fleet-chart__actual {
      @media screen and (min-width: ${BREAKPOINTS.XL}px) and (max-width: ${BREAKPOINTS.XXL}px) {
        text-align: right;
      }
    }

    .fleet-chart__planned {
      @media screen and (min-width: ${BREAKPOINTS.XL}px) and (max-width: ${BREAKPOINTS.XXL}px) {
        text-align: left;
      }
    }

    .fleet-chart__wrap-cols {
      display: flex;
      align-items: flex-end;
      min-height: 1%;
      height: 100%;
    }
  `}
`;
